// import Black from './Poppins-Black.ttf'
// import BlackItalic from './Poppins-BlackItalic.ttf'
import Bold from './Poppins-Bold.ttf'
// import BoldItalic from './Poppins-BoldItalic.ttf'
// import ExtraBold from './Poppins-ExtraBold.ttf'
// import ExtraBoldItalic from './Poppins-ExtraBoldItalic.ttf'
// import ExtraLight from './Poppins-ExtraLight.ttf'
// import ExtraLightItalic from './Poppins-ExtraLightItalic.ttf'
// import Italic from './Poppins-Italic.ttf'
// import Light from './Poppins-Light.ttf'
// import LightItalic from './Poppins-LightItalic.ttf'
// import Medium from './Poppins-Medium.ttf'
// import MediumItalic from './Poppins-MediumItalic.ttf'
import Regular from './Poppins-Regular.ttf'
import SemiBold from './Poppins-SemiBold.ttf'
// import SemiBoldItalic from './Poppins-SemiBoldItalic.ttf'
// import Thin from './Poppins-Thin.ttf'
// import ThinItalic from './Poppins-ThinItalic.ttf'


const poppins = [Regular]

const bold = [Bold]

const semi_bold = [SemiBold]

export { poppins, bold, semi_bold } 
